import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { FeaturedWork } from './components/FeaturedWork';
import { About } from './components/About';
import { Footer } from './components/Footer';
import { CaseStudy } from './components/CaseStudy';
import { initializeAnalytics, trackPageView } from './utils/analytics';
function Home() {
  return <>
      <Hero data-id="element-0" data-mp="2riknh5rqsbbj" />
      <FeaturedWork data-id="element-1" data-mp="2mlu5ue0ah7o0" />
      <About data-id="element-2" data-mp="2mmlsv0ftlx2o" />
    </>;
}

/**
 * Scrolls to the hash target after a route change so links like `/#work`
 * coming from a case study page land on the right section.
 */
function HashScroll() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const el = document.getElementById(hash.slice(1));
    if (!el) return;
    // Wait a frame so the route's content is mounted before measuring.
    const raf = requestAnimationFrame(() => {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });
    return () => cancelAnimationFrame(raf);
  }, [pathname, hash]);
  return null;
}
export function App() {
  const {
    pathname,
    search
  } = useLocation();
  useEffect(() => {
    initializeAnalytics();
  }, []);
  useEffect(() => {
    trackPageView(`${pathname}${search}`);
  }, [pathname, search]);
  return <div className="min-h-screen bg-background text-foreground selection:bg-accent selection:text-white" data-id="element-3" data-mp="82k72sfnuax">
      <HashScroll data-id="element-4" data-mp="2zng0qi58cgrv" />
      <Nav data-id="element-5" data-mp="33mf2jtvnzxf3" />
      <main data-id="element-6" data-mp="33m5bs42spm8c">
        <Routes data-id="element-7" data-mp="33nq73vwxp979">
          <Route path="/" element={<Home data-id="element-9" data-mp="33orki71fa7s5" />} data-id="element-8" data-mp="33n6zb810016y" />
          <Route path="/work/:slug" element={<CaseStudy data-id="element-11" data-mp="38kqb81a841vq" />} data-id="element-10" data-mp="38lrs4mdx7ild" />
          <Route path="*" element={<CaseStudy data-id="element-13" data-mp="38o4f5dyjcj5a" />} data-id="element-12" data-mp="38kgkgbhctqoz" />
        </Routes>
      </main>
      <Footer data-id="element-14" data-mp="3dlnukh6yz1yt" />
    </div>;
}